var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.footerNav
    ? _c(
        "ul",
        { staticClass: "c-mobile-nav-footer" },
        _vm._l(_vm.footerNav.navItems, function(navItem, index) {
          return _c(
            "li",
            {
              key: "j-mobile-nav-footer_" + index,
              staticClass: "c-mobile-nav-footer__item"
            },
            [
              navItem.linkUrl.startsWith("http")
                ? _c(
                    "a",
                    {
                      staticClass: "c-mobile-nav-footer__item-link t-heading-6",
                      attrs: {
                        href: navItem.linkUrl,
                        tabindex: _vm.tabindexStart + index
                      }
                    },
                    [_vm._v("\n      " + _vm._s(navItem.linkText) + "\n    ")]
                  )
                : _c(
                    "nuxt-link",
                    {
                      staticClass: "c-mobile-nav-footer__item-link t-heading-6",
                      attrs: {
                        to: navItem.linkUrl,
                        tabindex: _vm.tabindexStart + index
                      }
                    },
                    [_vm._v("\n      " + _vm._s(navItem.linkText) + "\n    ")]
                  )
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }